import axios from 'axios';
import {
  decrementRequisition,
  incrementRequisition,
} from '@/composables/useLoader';

const Api = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer: {
    indexes: null,
  },
});

export const ApiWithoutGlobalLoader = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer: {
    indexes: null,
  },
});

Api.interceptors.request.use(
  (config) => {
    incrementRequisition();
    return config;
  },
  (error) => {
    decrementRequisition();
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  (response) => {
    decrementRequisition();
    return response;
  },
  function (error) {
    decrementRequisition();
    return Promise.reject(error);
  }
);

Api.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
ApiWithoutGlobalLoader.defaults.headers.common['X-Requested-With'] =
  'XMLHttpRequest';

export const getAxiosError = (error: unknown, defaultError?: string) => {
  if (axios.isAxiosError(error) && error.response) {
    return (
      error.response.data.message ??
      defaultError ??
      `${error.response.status} - Erro na requisição`
    );
  }

  return error instanceof Error ? error.message : defaultError;
};

export default Api;
